<template>
    <div v-if="!loading" class="home">
        <div class="q-pa-sm row q-gutter-md justify-center">
        <q-card class="my-card justify-center" flat v-if="place">
        <q-card-section>
            <div class="text-h4">{{ title }}</div>
            <div class="text-subtitle1">Customer since {{createdAt}}</div>
        </q-card-section>
        <q-card-section>
            <perks-card :cssclass="'row q-px-md q-gutter-md'" :perk="pointsObj" :points="totalPoints" :perks="place.pointsToPerk" :updatedAtAgo="pointsObj.updatedAtAgo" />
        </q-card-section>
        <q-card-section  horizontal class="q-gutter-x-md q-ma-sm">
            <q-icon color="primary" name="history" size="lg" />
            <div class="text-left text-subtitle1" v-if="pointsObj">
                Visited <strong>{{pointsObj.visits}}</strong> times <br/>
                First Visit: {{pointsObj.createdAtAgo}}
            </div>
        </q-card-section>
        <q-card-section class="q-ma-sm q-pa-none">
            <points-history :rows="rows" title="Activity" :pagination="pagination" @paginate="paginate" />
        </q-card-section>
        </q-card>
        </div>
    </div>
    <div class="q-pa-md row q-gutter-md justify-center" v-else>
    <Spinner />
    </div>
</template>
<script>
import PerksCard from "@/components/PerksCard.vue";
import PointsHistory from "@/components/PointsHistory.vue";
import { computed, ref } from '@vue/reactivity';
import Spinner from "@/components/Spinner";
import { inject } from '@vue/runtime-core';
import { useRoute } from 'vue-router'
import { useStore } from 'vuex';
import router from "@/router";
import dateFormat from '@/helpers/dateFormat'

export default {
  components: {PerksCard, Spinner, PointsHistory},
  setup() {
    const rows = ref([])
    const place = ref(null)
    const totalPoints = ref(0)
    const pointsObj = ref(null)
    const loading = ref(false)
    const message = ref('')
    const merchant = ref(null)
    const firstPoint = ref('')
    const collectedPoints = ref('')
    const axios = inject('axios')
    const store = useStore()
    const route = useRoute()
    const error = ref(null)
    const perk = ref(null)
    merchant.value = route.params.merchant
    const ownerId = ref(null)
    const name = ref(null)
    const createdAt = ref(null)
    const pagination = ref({
      page: 1,
      rowsPerPage: 5,
      rowsNumber: 0
    })
    const title = computed(() => {
      return (merchant.value) ? name.value : place.value.name
    })

    const getRelatorios = () => {
      let timestamp = new Date()
      let date = timestamp.toLocaleDateString()
      let time = timestamp.toLocaleTimeString()
      firstPoint.value = 'First point(s) earned on ' + date + ' at ' + time
      let collected = 0
      rows.value.forEach(r => {
        if (r.isPerk) collected = collected + r.points
      })
      collectedPoints.value = 'Collected ' + collected + ' points collected recently.'
    }

    const getHistory = () => {
      axios.get(`${process.env.VUE_APP_URL}/points?page=${pagination.value.page}&itemsPerPage=${pagination.value.rowsPerPage}&user=${ownerId.value}&place=${place.value.id}&order%5BcreatedAt%5D=desc`,
      {
        headers: {
          'Content-Type': 'application/ld+json',
          'Accept': 'application/ld+json',
        }
      })
        .then(resp => {
          if (merchant.value) {
            getRelatorios()
          }
          let points = resp.data["hydra:member"].map(e => {
            return {
              ...e,
              createdAt: dateFormat(e.createdAt),
              message: (e.isPerk) ? 'Perk Collected' : (e.points > 1) ? e.points + ' points' : e.points + ' point'
            }
          })
          rows.value = points
          pagination.value.rowsNumber = Math.ceil(resp.data['hydra:totalItems'] / 5)
        })
        .catch(err => {
          loading.value = false
          error.value = 'An error ocurred when getting points history. Wait a few moments and try again.'
        })
    }

    const paginate = (page) => {
      pagination.value.page = page
      getHistory()
    }

    const getCard = () => { // get the user points to the chosen place
        loading.value = true
        axios.get(`${process.env.VUE_APP_URL}/cards?page=1&itemsPerPage=1&owner=${ownerId.value}&place=${place.value.id}`)
        .then(resp => {
          pointsObj.value = resp.data[0]
          totalPoints.value = pointsObj.value.points
          createdAt.value = dateFormat(resp.data[0].createdAt)

          let tocollect = place.value.pointsToPerk - totalPoints.value

          if (!name.value) name.value = (place.value.customer) ? place.value.customer : 'Anonymous' // TODO verificar de onde esse nome vai vir

          if (tocollect > 0) message.value = "and need " + tocollect + " point(s) to collect a perk at this place."
          else message.value = "and you have now a perk to collect at this place!"
        
          message.value = 'You have ' + totalPoints.value + " point(s) " + message.value

          getHistory()
        })
        .catch(err => {
          error.value = 'An error ocurred when getting cards. Wait a few moments and try again.'
        })
        .finally(() => loading.value = false)
    }
    
    store.dispatch('verifyLogged')
    .then(resp => {
      place.value = store.getters.stateHPlace
      ownerId.value =  store.getters.stateHUser.id

      if (merchant.value) {
        name.value = store.getters.stateHUser.name
        place.value = store.getters.statePlace  
      }

      perk.value = {
       name: place.value.name,
       id: place.value.id,
       logo: place.value.logo
      }

      getCard()
    })
    .catch(error => {
      store.commit('setUser', null)
      store.commit('setClearHistory')
      store.commit('clearPlace')
      router.push('/')
    })

    return {rows, place, totalPoints, loading, message, getHistory, firstPoint, collectedPoints,
    merchant, pointsObj, name, perk, pagination, paginate, createdAt, title}
  },
}
</script>
